import { call, put, takeLatest } from "redux-saga/effects";
import { CommonAPI } from "../../../api/commonAPI";
import {
  GET_LISTINGS_DATA_REQUEST,
  GET_LISTINGS_DATA_SUCCESS,
  GET_LISTINGS_DATA_ERROR
} from "../../actions";

function* workerListingsData(action: {
  type: string;
  payload: any;
  meta?: { period?: string };
}): Generator<any> {
  try {
    const response: any = yield call(
      CommonAPI.getListingsData,
      action.payload
    );
    // Filter only all_time_income and unique_reservations_* keys
    let filtered: Record<string, any> = {};
    const fullData = response?.data || {};
    // Determine period key
    let period =
      action?.meta?.period ||
      (action.payload && action.payload.param) || "summary";
    yield put({
      type: GET_LISTINGS_DATA_SUCCESS,
      payload: { [period]: fullData },
    });
  } catch (error) {
    yield put({ type: GET_LISTINGS_DATA_ERROR, payload: error });
  }
}

export function* watcherListingsData() {
  yield takeLatest(GET_LISTINGS_DATA_REQUEST, workerListingsData);
}

